import { initializeApp } from 'firebase/app';
import { 
    getAuth, 
    createUserWithEmailAndPassword, 
    signInWithEmailAndPassword,
    signOut,
    sendEmailVerification,
    sendPasswordResetEmail,
    updateProfile,
    onAuthStateChanged
} from 'firebase/auth';

// Your Firebase configuration (REPLACE WITH YOUR ACTUAL CONFIG)
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCfDBTs4Rzh_AhH7hiU3pjrxOSYUV_YiWc",
  authDomain: "valora-gems.firebaseapp.com",
  projectId: "valora-gems",
  storageBucket: "valora-gems.firebasestorage.app",
  messagingSenderId: "594695837129",
  appId: "1:594695837129:web:b05aaeb2e2693865748418",
  measurementId: "G-L23ZKXYK1Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Sign Up - Creates user in Firebase
export const signUpWithFirebase = async (email, password, displayName) => {
    try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        // Update profile with name
        await updateProfile(userCredential.user, { displayName });
        // Send verification email
        await sendEmailVerification(userCredential.user);
        return { 
            success: true, 
            user: userCredential.user,
            message: "Verification email sent! Please verify your email before logging in."
        };
    } catch (error) {
        let errorMessage = error.message;
        if (error.code === 'auth/email-already-in-use') {
            errorMessage = 'Email already in use';
        } else if (error.code === 'auth/weak-password') {
            errorMessage = 'Password should be at least 6 characters';
        }
        return { success: false, error: errorMessage };
    }
};

// Sign In - Authenticates with Firebase
export const signInWithFirebase = async (email, password) => {
    try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        
        // Check if email is verified
        if (!user.emailVerified) {
            await sendEmailVerification(user);
            return { 
                success: false, 
                error: 'Please verify your email before logging in. A new verification email has been sent.',
                needsVerification: true 
            };
        }
        
        const idToken = await user.getIdToken();
        return { 
            success: true, 
            user: user,
            idToken: idToken,
            firebaseUid: user.uid
        };
    } catch (error) {
        let errorMessage = error.message;
        if (error.code === 'auth/user-not-found') {
            errorMessage = 'No account found with this email';
        } else if (error.code === 'auth/wrong-password') {
            errorMessage = 'Incorrect password';
        }
        return { success: false, error: errorMessage };
    }
};

// Logout
export const logOut = async () => {
    try {
        await signOut(auth);
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

// Resend Verification Email
export const resendVerificationEmail = async () => {
    try {
        const user = auth.currentUser;
        if (user && !user.emailVerified) {
            await sendEmailVerification(user);
            return { success: true, message: 'Verification email resent!' };
        }
        return { success: false, error: 'Email already verified or no user logged in.' };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

// Reset Password
export const resetPassword = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        return { success: true, message: 'Password reset email sent!' };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const getCurrentUser = () => {
    return auth.currentUser;
};

export const onAuthStateChange = (callback) => {
    return onAuthStateChanged(auth, callback);
};

export { auth };